import React from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { DeliverySite_GetCompanies_Basic, DeliverySite_GetDHCs_Basic, DeliverySite_GetEmployeeDetails, DeliverySite_GetEmployees, DeliverySite_GetLeaders_Basic, DeliverySite_GetMiddleLeaders_Basic, DeliverySite_GetTopLeaders_Basic, DeliverySite_InsertEditEmployee } from '../../../Services/Actions';
import Select from 'react-select';
import Popover from 'react-popover';

import * as styles from './styles';

import ButtonGroup from '../../../Components/Buttons/ButtonGroup';
import Loading from '../../../Components/Loading';
import MultiText from '../../../Components/Text/MultiText';
import PageText from '../../../Components/Text/PageText';
import PaginationContainer from '../../../Components/PaginationCounter';
import ProfilePhoto from '../../../Components/ProfilePhoto';
import Spacer from '../../../Components/Spacer';

import Info from '../../../Modals/Info';

import DownArrow from '../../../Assets/Icons/DownArrow.png';
import InfoIcon from '../../../Assets/Icons/Info.png';
import Plus from '../../../Assets/Icons/PlusSign_White.png';
import UpArrow from '../../../Assets/Icons/UpArrow.png';

import { emailValidator, formatCallDuration } from '../../../Functions';

const EMPLOYEE_TABLE_COLUMNS = [
    { Id: 1, SortCol: null, Title: 'User Id' },
    { Id: 2, SortCol: 'DisplayName', Title: 'Name' },
    { Id: 3, SortCol: null, Title: 'Active DHC in Order' },
    { Id: 4, SortCol: null, Title: 'Company' },
    { Id: 5, SortCol: null, Title: 'Product' },
    { Id: 6, SortCol: null, Title: 'Calls' }
];

const customStyles = {
    valueContainer: (provided, state) => ({
        ...provided,
        textOverflow: "ellipsis",
        maxWidth: "90%",
        whiteSpace: "nowrap",
        overflow: "hidden",
        display: "initial"
    }),
    input: (provided, state) => ({
        ...provided,
        minWidth: '20%'
    })
}

class EmployeesComponent extends React.Component {
    TimeoutId = null;

    state = {
        DisplayName_Previous: '',
        DisplayName: '',
        Employees: [],
        IsMoreResults: null,
        PageNo: 1,
        PageSize: 10,
        Sorting: {
            SortCol: 'DisplayName',
            SortDir: 'ASC'
        },
        TotalRecords: null,

        Filters: {
            Companies: {
                Companies: [],
                IsLoading: false,
                Loaded: false,
                Selected: []
            },
            DHCs: {
                IsLoading: false,
                Loaded: false,
                Selected: [],
                Users: []
            },
            Leaders: {
                IsLoading: false,
                Loaded: false,
                Selected: [],
                Users: []
            },
            MiddleLeaders: {
                IsLoading: false,
                Loaded: false,
                Selected: [],
                Users: []
            },
            TopLeaders: {
                IsLoading: false,
                Loaded: false,
                Selected: [],
                Users: []
            }
        },

        PopoverIsOpen_Companies: false,
        PopoverIsOpen_DHCs: false,
        PopoverIsOpen_Leaders: false,
        PopoverIsOpen_MiddleLeaders: false,
        PopoverIsOpen_TopLeaders: false,
        PopoverIsOpen_Users: false,

        ShowAddEmployeeModal: false,
        ShowAddEmployeeModal_EmployeeEmail: '',
        ShowAddEmployeeModal_CompanyId: null,
        ShowAddEmployeeModal_DHC_UserId: null,
        ShowAddEmployeeModal_Loading: false,

        ShowEmployeeDetailModal: false,
        ShowEmployeeDetailModal_Data: {},
        ShowEmployeeDetailModal_Loading: false
    }

    componentDidMount() {
        this.onLoadEmployees();
    }

    onAddEmployee = () => {
        var { ShowAddEmployeeModal_EmployeeEmail: Email, ShowAddEmployeeModal_CompanyId: CompanyId, ShowAddEmployeeModal_DHC_UserId: DefaultDHC_UserId } = this.state;

        this.setState({ ShowAddEmployeeModal_Loading: true }, () => {
            this.props.DeliverySite_InsertEditEmployee({ CompanyId, DefaultDHC_UserId, Email }).then(() => {
                this.onToggleShowAddEmployeeModal({ ShowAddEmployeeModal: false });
                this.onLoadEmployees();
            })
        })
    }

    onBlurFilter_Companies = () => {
        this.setState({ PageNo: 1 }, () => this.onLoadEmployees());
    }

    onBlurFilter_DHCs = () => {
        this.setState({ PageNo: 1 }, () => this.onLoadEmployees());
    }

    onBlurFilter_Leaders = () => {
        this.setState({ PageNo: 1 }, () => this.onLoadEmployees());
    }

    onBlurFilter_MiddleLeaders = () => {
        this.setState({ PageNo: 1 }, () => this.onLoadEmployees());
    }

    onBlurFilter_TopLeaders = () => {
        this.setState({ PageNo: 1 }, () => this.onLoadEmployees());
    }

    onBlurSearchEmployees = () => {
        var { DisplayName, DisplayName_Previous } = this.state;

        if (DisplayName !== DisplayName_Previous) {
            this.setState({ DisplayName_Previous: DisplayName, PageNo: 1 }, () => this.onLoadEmployees());
        }
    }

    onChangeAddEmployeeModal_Company = data => {
        this.setState({ ShowAddEmployeeModal_CompanyId: data.CompanyId });
    }

    onChangeAddEmployeeModal_DHC = data => {
        this.setState({ ShowAddEmployeeModal_DHC_UserId: data.UserId });
    }

    onChangeAddEmployeeModal_EmployeeEmail = event => {
        this.setState({ ShowAddEmployeeModal_EmployeeEmail: event.target.value });
    }

    onChangeEmployeeSearch = event => {
        this.setState({ DisplayName: event.target.value });
    }

    onChangeFilter_Companies = data => {
        if (!data) data = [];
        
        var Filters = { ...this.state.Filters };
        Filters.Companies.Selected = data;

        this.setState({ Filters });
    }

    onChangeFilter_DHCs = data => {
        if (!data) data = [];
        
        var Filters = { ...this.state.Filters };
        Filters.DHCs.Selected = data;

        this.setState({ Filters });
    }

    onChangeFilter_Leaders = data => {
        if (!data) data = [];
        
        var Filters = { ...this.state.Filters };
        Filters.Leaders.Selected = data;

        this.setState({ Filters });
    }

    onChangeFilter_MiddleLeaders = data => {
        if (!data) data = [];
        
        var Filters = { ...this.state.Filters };
        Filters.MiddleLeaders.Selected = data;

        this.setState({ Filters });
    }

    onChangeFilter_TopLeaders = data => {
        if (!data) data = [];
        
        var Filters = { ...this.state.Filters };
        Filters.TopLeaders.Selected = data;

        this.setState({ Filters });
    }

    onFocusFilter_Companies = () => {
        if (!this.state.Filters.Companies.Loaded) {
            var Filters = { ...this.state.Filters };
            Filters.Companies = { ...Filters.Companies };
            Filters.Companies.IsLoading = true;

            this.setState({ Filters }, () => {
                this.props.DeliverySite_GetCompanies_Basic({}).then(({ Companies }) => {
                    Filters.Companies.IsLoading = false;
                    Filters.Companies.Companies = Companies;
                    Filters.Companies.Loaded = true;
                    this.setState({ Filters });
                });
            });
        }
    }

    onFocusFilter_DHCs = () => {
        if (!this.state.Filters.DHCs.Loaded) {
            var Filters = { ...this.state.Filters };
            Filters.DHCs = { ...Filters.DHCs };
            Filters.DHCs.IsLoading = true;

            this.setState({ Filters }, () => {
                this.props.DeliverySite_GetDHCs_Basic().then(({ Users }) => {
                    Filters.DHCs.IsLoading = false;
                    Filters.DHCs.Users = Users;
                    Filters.DHCs.Loaded = true;
                    this.setState({ Filters });
                });
            });
        }
    }

    onFocusFilter_Leaders = () => {
        if (!this.state.Filters.Leaders.Loaded) {
            var Filters = { ...this.state.Filters };
            Filters.Leaders = { ...Filters.Leaders };
            Filters.Leaders.IsLoading = true;

            this.setState({ Filters }, () => {
                this.props.DeliverySite_GetLeaders_Basic().then(({ Users }) => {
                    Filters.Leaders.IsLoading = false;
                    Filters.Leaders.Users = Users;
                    Filters.Leaders.Loaded = true;
                    this.setState({ Filters });
                });
            });
        }
    }

    onFocusFilter_MiddleLeaders = () => {
        if (!this.state.Filters.MiddleLeaders.Loaded) {
            var Filters = { ...this.state.Filters };
            Filters.MiddleLeaders = { ...Filters.MiddleLeaders };
            Filters.MiddleLeaders.IsLoading = true;

            this.setState({ Filters }, () => {
                this.props.DeliverySite_GetMiddleLeaders_Basic().then(({ Users }) => {
                    Filters.MiddleLeaders.IsLoading = false;
                    Filters.MiddleLeaders.Users = Users;
                    Filters.MiddleLeaders.Loaded = true;
                    this.setState({ Filters });
                });
            });
        }
    }

    onFocusFilter_TopLeaders = () => {
        if (!this.state.Filters.TopLeaders.Loaded) {
            var Filters = { ...this.state.Filters };
            Filters.TopLeaders = { ...Filters.TopLeaders };
            Filters.TopLeaders.IsLoading = true;

            this.setState({ Filters }, () => {
                this.props.DeliverySite_GetTopLeaders_Basic().then(({ Users }) => {
                    Filters.TopLeaders.IsLoading = false;
                    Filters.TopLeaders.Users = Users;
                    Filters.TopLeaders.Loaded = true;
                    this.setState({ Filters });
                });
            });
        }
    }

    onLoadEmployees = Increment => {
        var { DisplayName, Filters: { Companies, DHCs, Leaders, MiddleLeaders, TopLeaders }, PageNo, PageSize, Sorting: { SortCol, SortDir } } = this.state;

        var CompanyIds = Companies.Selected.length > 0 ? Companies.Selected.map(({ CompanyId }) => CompanyId).join(',') : null;
        var DHC_UserIds = DHCs.Selected.length > 0 ? DHCs.Selected.map(({ UserId }) => UserId).join(',') : null;
        var Leader_UserIds = Leaders.Selected.length > 0 ? Leaders.Selected.map(({ UserId }) => UserId).join(',') : null;
        var MiddleLeader_UserIds = MiddleLeaders.Selected.length > 0 ? MiddleLeaders.Selected.map(({ UserId }) => UserId).join(',') : null;
        var TopLeader_UserIds = TopLeaders.Selected.length > 0 ? TopLeaders.Selected.map(({ UserId }) => UserId).join(',') : null;

        if (Increment) PageNo++;

        this.props.DeliverySite_GetEmployees({ CompanyIds, DHC_UserIds, EmployeeName: DisplayName, Leader_UserIds, MiddleLeader_UserIds, PageNo, PageSize, SortCol, SortDir, TopLeader_UserIds }).then(({ Employees, IsMoreResults, TotalRecords }) => {
            this.setState({ Employees, IsMoreResults, TotalRecords });
        });
    }

    onPaginate = ({ NewPageNo }) => {
        if (this.statePageNo !== NewPageNo) this.setState({ PageNo: NewPageNo }, () => this.onLoadEmployees());
    }

    onTogglePopover = PopoverType => {
        this.setState({ [PopoverType]: !this.state[PopoverType] }, () => {
            if (!this.state[PopoverType] && !!this.TimeoutId) clearTimeout(this.TimeoutId);
        });
    }

    onToggleShowAddEmployeeModal = ({ ShowAddEmployeeModal }) => {
        if (!ShowAddEmployeeModal) this.setState({ ShowAddEmployeeModal, ShowAddEmployeeModal_EmployeeEmail: '', ShowAddEmployeeModal_CompanyId: null, ShowAddEmployeeModal_DHC_UserId: null, ShowAddEmployeeModal_Loading: false });
        else this.setState({ ShowAddEmployeeModal });
    }

    onToggleShowEmployeeDetailModal = ({ Employee_UserId, ShowEmployeeDetailModal }) => {
        if (!ShowEmployeeDetailModal) this.setState({ ShowEmployeeDetailModal, ShowEmployeeDetailModal_Loading: false });
        else {
            this.setState({ ShowEmployeeDetailModal, ShowEmployeeDetailModal_Loading: true }, () => {
                this.props.DeliverySite_GetEmployeeDetails({ Employee_UserId }).then(({ UserDetails }) => {
                    this.setState({ ShowEmployeeDetailModal_Data: UserDetails, ShowEmployeeDetailModal_Loading: false });
                })
            });
        }
    }

    onToggleSorting = ({ SortCol: NewSortCol }) => {
        var { SortCol, SortDir } = this.state.Sorting;

        // SortDir Goes From ASC --> DESC --> Nothing

        // Toggle Sorting Of Already Sorted Column
            if (SortCol === NewSortCol) {
                if (SortDir === 'ASC') SortDir = 'DESC';
                else if (SortDir === 'DESC') {
                    SortDir = '';
                    SortCol = '';
                }
                else if (SortDir === '') SortDir = 'ASC';
            }
        // Start Sorting On New Column
            else {
                SortCol = NewSortCol;
                SortDir = 'ASC';
            }

        this.setState({ PageNo: 1, Sorting: { SortCol, SortDir } }, () => this.onLoadEmployees());
    }

    renderAddEmployeeModal = () => {
        var { t } = this.props;
        var { ShowAddEmployeeModal, ShowAddEmployeeModal_EmployeeEmail, ShowAddEmployeeModal_CompanyId, ShowAddEmployeeModal_DHC_UserId, ShowAddEmployeeModal_Loading } = this.state;

        if (ShowAddEmployeeModal) {
            return (
                <Info
                    BottomButton="submit"
                    BottomButtonOnClick={this.onAddEmployee}
                    BottomButtonDisabled={!ShowAddEmployeeModal_EmployeeEmail || !emailValidator(ShowAddEmployeeModal_EmployeeEmail) || !ShowAddEmployeeModal_CompanyId || !ShowAddEmployeeModal_DHC_UserId}
                    BottomButtonText={t('_save')}
                    InformationRenderer={this.renderAddEmployeeModal_Information}
                    Loading={(ShowAddEmployeeModal_Loading)}
                    OnHide={() => this.onToggleShowAddEmployeeModal({ ShowAddEmployeeModal: false })}
                    Show={ShowAddEmployeeModal}
                />
            );
        }
    }

    renderAddEmployeeModal_Information = () => {
        var { Filters: { Companies, DHCs }, ShowAddEmployeeModal_EmployeeEmail } = this.state;

        return (
            <styles.InsertEditModalContainer className="InsertEditModalContainer">
                <PageText FontFamily="medium" FontSize="medium-3" JustifyContent="center" NoMargin Text="Add Employee" TextAlign="center" />

                <Spacer Size="extra-small" />

                <styles.SearchInput
                    AutoFocus
                    FontSize="medium-1"
                    NoLabel
                    NoMargin
                    OnChange={this.onChangeAddEmployeeModal_EmployeeEmail}
                    Placeholder="Employee email"
                    Size="medium"
                    Type="text"
                    Value={ShowAddEmployeeModal_EmployeeEmail}
                />

                <Spacer Size="medium" />

                <PageText FontFamily="medium" FontSize="medium-1" JustifyContent="center" NoMargin Text="Choose company" TextAlign="center" />

                <Select
                    closeMenuOnSelect={false}
                    getOptionLabel={option => option.CompanyName}
                    getOptionValue={option => option.CompanyId}
                    isLoading={Companies.IsLoading}
                    isMulti={false}
                    // components={{ ValueContainer }}
                    hideSelectedOptions={true}
                    isSearchable
                    onChange={this.onChangeAddEmployeeModal_Company}
                    onFocus={this.onFocusFilter_Companies}
                    options={Companies.Companies}
                    placeholder="Companies"
                    styles={customStyles}
                    menuPosition="fixed"
                />

                <Spacer Size="medium" />

                <PageText FontFamily="medium" FontSize="medium-1" JustifyContent="center" NoMargin Text="Choose default DHC" TextAlign="center" />

                <Select
                    closeMenuOnSelect={false}
                    getOptionLabel={option => option.DisplayName}
                    getOptionValue={option => option.UserId}
                    isLoading={DHCs.IsLoading}
                    isMulti={false}
                    // components={{ ValueContainer }}
                    hideSelectedOptions={true}
                    isSearchable
                    onChange={this.onChangeAddEmployeeModal_DHC}
                    onFocus={this.onFocusFilter_DHCs}
                    options={DHCs.Users}
                    placeholder="DHCs"
                    styles={customStyles}
                    menuPosition="fixed"
                />
            </styles.InsertEditModalContainer>
        );
    }

    renderEmployees = () => {
        var { Employees, PageNo, PageSize, Sorting: { SortCol: StateSortCol, SortDir: StateSortDir }, TotalRecords } = this.state;

        return (
            <styles.BodyContainer className="BodyContainer">
                <styles.BodyHeader className="BodyHeader">
                    <PageText FontFamily="medium" FontSize="large" JustifyContent="flex-start" NoMargin Text="Employees" TextAlign="left" />

                    <styles.BodyHeaderRight className="BodyHeaderRight">
                        <ButtonGroup
                            Buttons={[{ BackgroundGradient: "gradient1", Border: 'none', Color: 'white', ColorHover: 'white', Icon: Plus, IconPosition: 'left', IconSize: { Height: '20px', Width: '20px' }, OnClick: () => this.onToggleShowAddEmployeeModal({ ShowAddEmployeeModal: true }), Title: "New Employee" }]}
                            ButtonWidth="fit-content"
                            ContainerWidth="fit-content"
                            JustifyContent="center"
                        />
                    </styles.BodyHeaderRight>
                </styles.BodyHeader>

                <Spacer Size="small" />

                {this.renderViewCount()}

                {
                    TotalRecords > 0 &&
                    <>
                        <Spacer Size="small" />

                        {
                            (PageNo !== 1 || PageSize < TotalRecords) &&
                            <>
                                <PaginationContainer OnPaginate={this.onPaginate} PageNo={PageNo} PageSize={PageSize} TotalRecords={TotalRecords} />
        
                                <Spacer Size="medium" />
                            </>
                        }

                        <styles.UsersContainer className="UsersContainer">
                            <styles.UsersTableContainer className="UsersTableContainer">
                                <styles.UsersTable className="UsersTable">
                                    <styles.UsersTableHeader className="UsersTableHeader">
                                        <styles.UsersTableHeaderRow className="UsersTableHeaderRow">
                                            {
                                                EMPLOYEE_TABLE_COLUMNS.map(({ Id, SortCol, Title }) => {
                                                    return (
                                                        <styles.UsersTableHeaderCell className="UsersTableHeaderCell" key={Id} onClick={SortCol ? () => this.onToggleSorting({ SortCol }) : null}>
                                                            <styles.UsersTableHeaderCellInnerDiv className="UsersTableHeaderCellInnerDiv">
                                                                <PageText FontFamily="semibold" FontSize="small" JustifyContent="flex-start" NoMargin TextAlign="left" Text={Title} />
                                                                {SortCol ? StateSortCol === SortCol && <styles.SortingIcon ImageSrc={StateSortDir === 'DESC' ? DownArrow : UpArrow} /> : null}
                                                            </styles.UsersTableHeaderCellInnerDiv>
                                                        </styles.UsersTableHeaderCell>
                                                    );
                                                })
                                            }
                                        </styles.UsersTableHeaderRow>
                                    </styles.UsersTableHeader>
                                    <styles.UsersTableBody className="UsersTableBody">
                                        {
                                            Employees.map((User, UserIndex) => {
                                                var {
                                                    DisplayName, ProfilePhotoUrl, Sex, UserId,
                                                    DHC_DisplayName, DHC_ProfilePhotoUrl, DHC_Sex,
                                                    CompanyName, ProductName,
                                                    CallDays: Days, CallHours: Hours, CallMinutes: Minutes, CallSeconds: Seconds
                                                } = User;

                                                return (
                                                    <styles.UsersTableBodyRow className="UsersTableBodyRow" key={UserId}>
                                                        <styles.UsersTableBodyCell className="UsersTableBodyCell">
                                                            {UserId}
                                                        </styles.UsersTableBodyCell>
                                                        <styles.UsersTableBodyCell className="UsersTableBodyCell" onClick={() => this.onToggleShowEmployeeDetailModal({ Employee_UserId: UserId, ShowEmployeeDetailModal: true })}>
                                                            <styles.UsersTableBodyCellFlexed className="UsersTableBodyCellFlexed">
                                                                <styles.ProfilePhotoContainer className="ProfilePhotoContainer">
                                                                    <ProfilePhoto Sex={Sex || 'Male'} Size="small-3" Source={ProfilePhotoUrl || ''} />
                                                                </styles.ProfilePhotoContainer>
                                                                {DisplayName}
                                                            </styles.UsersTableBodyCellFlexed>
                                                        </styles.UsersTableBodyCell>
                                                        <styles.UsersTableBodyCell className="UsersTableBodyCell">
                                                            {
                                                                !!DHC_DisplayName &&
                                                                <>
                                                                    <styles.UsersTableBodyCellFlexed className="UsersTableBodyCellFlexed">
                                                                        <styles.ProfilePhotoContainer className="ProfilePhotoContainer">
                                                                            <ProfilePhoto Sex={DHC_Sex || 'Male'} Size="small-3" Source={DHC_ProfilePhotoUrl || ''} />
                                                                        </styles.ProfilePhotoContainer>
                                                                        {DHC_DisplayName}
                                                                    </styles.UsersTableBodyCellFlexed>
                                                                </>
                                                            }
                                                        </styles.UsersTableBodyCell>
                                                        <styles.UsersTableBodyCell className="UsersTableBodyCell">
                                                            {CompanyName}
                                                        </styles.UsersTableBodyCell>
                                                        <styles.UsersTableBodyCell className="UsersTableBodyCell">
                                                            {ProductName}
                                                        </styles.UsersTableBodyCell>
                                                        <styles.UsersTableBodyCell className="UsersTableBodyCell">
                                                            {formatCallDuration({ Days, Hours, Minutes, Seconds })}
                                                        </styles.UsersTableBodyCell>
                                                    </styles.UsersTableBodyRow>
                                                )
                                            })
                                        }
                                    </styles.UsersTableBody>
                                </styles.UsersTable>
                            </styles.UsersTableContainer>
                        </styles.UsersContainer>
                    </>
                }
            </styles.BodyContainer>
        );
    }

    renderFilters = () => {
        var { t } = this.props;

        const popoverProps_Companies = {
            isOpen: this.state.PopoverIsOpen_Companies,
            preferPlace: 'below',
            onOuterAction: () => this.onTogglePopover('PopoverIsOpen_Companies'),
            body: this.renderPopoverContent('Companies'),
            tipSize: 0.01
        }

        const popoverProps_DHCs = {
            isOpen: this.state.PopoverIsOpen_DHCs,
            preferPlace: 'below',
            onOuterAction: () => this.onTogglePopover('PopoverIsOpen_DHCs'),
            body: this.renderPopoverContent('DHCs'),
            tipSize: 0.01
        }

        const popoverProps_Leaders = {
            isOpen: this.state.PopoverIsOpen_Leaders,
            preferPlace: 'below',
            onOuterAction: () => this.onTogglePopover('PopoverIsOpen_Leaders'),
            body: this.renderPopoverContent('Leaders'),
            tipSize: 0.01
        }

        const popoverProps_MiddleLeaders = {
            isOpen: this.state.PopoverIsOpen_MiddleLeaders,
            preferPlace: 'below',
            onOuterAction: () => this.onTogglePopover('PopoverIsOpen_MiddleLeaders'),
            body: this.renderPopoverContent('MiddleLeaders'),
            tipSize: 0.01
        }

        const popoverProps_TopLeaders = {
            isOpen: this.state.PopoverIsOpen_TopLeaders,
            preferPlace: 'below',
            onOuterAction: () => this.onTogglePopover('PopoverIsOpen_TopLeaders'),
            body: this.renderPopoverContent('TopLeaders'),
            tipSize: 0.01
        }

        const popoverProps_Users = {
            isOpen: this.state.PopoverIsOpen_Users,
            preferPlace: 'below',
            onOuterAction: () => this.onTogglePopover('PopoverIsOpen_Users'),
            body: this.renderPopoverContent('Users'),
            tipSize: 0.01
        }

        var { DisplayName, Filters: { Companies, DHCs, Leaders, MiddleLeaders, TopLeaders }} = this.state;

        return (
            <styles.FiltersContainer className="FiltersContainer">
                <PageText FontFamily="bold" FontSize="medium-1" JustifyContent="flex-start" NoMargin Text="Filters" TextAlign="left" />

                <Spacer Size="extra-small" />

                <styles.FiltersSubContainer className="FiltersSubContainer">
                    <styles.FilterContainer className="FilterContainer">
                        <styles.FilterHeaderContainer className="FilterHeaderContainer">
                            <PageText FontFamily="medium" FontSize="medium-1" JustifyContent="flex-start" NoMargin TextAlign="left" Text="Search Employees" />

                            <Popover {...popoverProps_Users}>
                                <styles.MaxPercentInfoIcon ImageSrc={InfoIcon} OnMouseEnter={() => this.onTogglePopover('PopoverIsOpen_Users')} OnMouseLeave={() => this.onTogglePopover('PopoverIsOpen_Users')} />
                            </Popover>
                        </styles.FilterHeaderContainer>

                        <Spacer Size="extra-extra-small" />

                        <styles.SearchUsersInput
                            FontSize="medium-1"
                            NoLabel
                            NoMargin
                            OnBlur={this.onBlurSearchEmployees}
                            OnChange={this.onChangeEmployeeSearch}
                            Placeholder={t('_search')}
                            Size="medium"
                            Type="text"
                            Value={DisplayName}
                        />
                    </styles.FilterContainer>

                    <styles.FilterContainer className="FilterContainer">
                        <styles.FilterHeaderContainer className="FilterHeaderContainer">
                            <PageText FontFamily="medium" FontSize="medium-1" JustifyContent="flex-start" NoMargin TextAlign="left" Text="Companies" />

                            <Popover {...popoverProps_Companies}>
                                <styles.MaxPercentInfoIcon ImageSrc={InfoIcon} OnMouseEnter={() => this.onTogglePopover('PopoverIsOpen_Companies')} OnMouseLeave={() => this.onTogglePopover('PopoverIsOpen_Companies')} />
                            </Popover>
                        </styles.FilterHeaderContainer>

                        <Spacer Size="extra-extra-small" />

                        <Select
                            closeMenuOnSelect={false}
                            getOptionLabel={option => option.CompanyName}
                            getOptionValue={option => option.CompanyId}
                            isLoading={Companies.IsLoading}
                            isMulti
                            // components={{ ValueContainer }}
                            hideSelectedOptions={true}
                            isSearchable
                            onBlur={this.onBlurFilter_Companies}
                            onChange={data => this.onChangeFilter_Companies(data)}
                            onFocus={this.onFocusFilter_Companies}
                            options={Companies.Companies}
                            placeholder={t('Filter by Company')}
                            styles={customStyles}
                            menuPosition="fixed"
                        />
                    </styles.FilterContainer>

                    <styles.FilterContainer className="FilterContainer">
                        <styles.FilterHeaderContainer className="FilterHeaderContainer">
                            <PageText FontFamily="medium" FontSize="medium-1" JustifyContent="flex-start" NoMargin TextAlign="left" Text="DHCs" />

                            <Popover {...popoverProps_DHCs}>
                                <styles.MaxPercentInfoIcon ImageSrc={InfoIcon} OnMouseEnter={() => this.onTogglePopover('PopoverIsOpen_DHCs')} OnMouseLeave={() => this.onTogglePopover('PopoverIsOpen_DHCs')} />
                            </Popover>
                        </styles.FilterHeaderContainer>

                        <Spacer Size="extra-extra-small" />

                        <Select
                            closeMenuOnSelect={false}
                            getOptionLabel={option => option.DisplayName}
                            getOptionValue={option => option.UserId}
                            isLoading={DHCs.IsLoading}
                            isMulti
                            // components={{ ValueContainer }}
                            hideSelectedOptions={true}
                            isSearchable
                            onBlur={this.onBlurFilter_DHCs}
                            onChange={data => this.onChangeFilter_DHCs(data)}
                            onFocus={this.onFocusFilter_DHCs}
                            options={DHCs.Users}
                            placeholder={t('Filter by DHC')}
                            styles={customStyles}
                            menuPosition="fixed"
                        />
                    </styles.FilterContainer>

                    <styles.FilterContainer className="FilterContainer">
                        <styles.FilterHeaderContainer className="FilterHeaderContainer">
                            <PageText FontFamily="medium" FontSize="medium-1" JustifyContent="flex-start" NoMargin TextAlign="left" Text="Leaders" />

                            <Popover {...popoverProps_Leaders}>
                                <styles.MaxPercentInfoIcon ImageSrc={InfoIcon} OnMouseEnter={() => this.onTogglePopover('PopoverIsOpen_Leaders')} OnMouseLeave={() => this.onTogglePopover('PopoverIsOpen_Leaders')} />
                            </Popover>
                        </styles.FilterHeaderContainer>

                        <Spacer Size="extra-extra-small" />

                        <Select
                            closeMenuOnSelect={false}
                            getOptionLabel={option => option.DisplayName}
                            getOptionValue={option => option.UserId}
                            isLoading={Leaders.IsLoading}
                            isMulti
                            // components={{ ValueContainer }}
                            hideSelectedOptions={true}
                            isSearchable
                            onBlur={this.onBlurFilter_Leaders}
                            onChange={data => this.onChangeFilter_Leaders(data)}
                            onFocus={this.onFocusFilter_Leaders}
                            options={Leaders.Users}
                            placeholder={t('Filter by Leader')}
                            styles={customStyles}
                            menuPosition="fixed"
                        />
                    </styles.FilterContainer>

                    <styles.FilterContainer className="FilterContainer">
                        <styles.FilterHeaderContainer className="FilterHeaderContainer">
                            <PageText FontFamily="medium" FontSize="medium-1" JustifyContent="flex-start" NoMargin TextAlign="left" Text="Middle Leaders" />

                            <Popover {...popoverProps_MiddleLeaders}>
                                <styles.MaxPercentInfoIcon ImageSrc={InfoIcon} OnMouseEnter={() => this.onTogglePopover('PopoverIsOpen_MiddleLeaders')} OnMouseLeave={() => this.onTogglePopover('PopoverIsOpen_MiddleLeaders')} />
                            </Popover>
                        </styles.FilterHeaderContainer>

                        <Spacer Size="extra-extra-small" />

                        <Select
                            closeMenuOnSelect={false}
                            defaultValue={[]}
                            getOptionLabel={option => option.DisplayName}
                            getOptionValue={option => option.UserId}
                            isLoading={MiddleLeaders.IsLoading}
                            isMulti
                            // components={{ ValueContainer }}
                            hideSelectedOptions={false}
                            isSearchable
                            onBlur={this.onBlurFilter_MiddleLeaders}
                            onChange={data => this.onChangeFilter_MiddleLeaders(data)}
                            onFocus={this.onFocusFilter_MiddleLeaders}
                            options={MiddleLeaders.Users}
                            placeholder={t('Filter by Middle Leader')}
                            styles={customStyles}
                            menuPosition="fixed"
                        />
                    </styles.FilterContainer>

                    <styles.FilterContainer className="FilterContainer">
                        <styles.FilterHeaderContainer className="FilterHeaderContainer">
                            <PageText FontFamily="medium" FontSize="medium-1" JustifyContent="flex-start" NoMargin TextAlign="left" Text="Top Leaders" />

                            <Popover {...popoverProps_TopLeaders}>
                                <styles.MaxPercentInfoIcon ImageSrc={InfoIcon} OnMouseEnter={() => this.onTogglePopover('PopoverIsOpen_TopLeaders')} OnMouseLeave={() => this.onTogglePopover('PopoverIsOpen_TopLeaders')} />
                            </Popover>
                        </styles.FilterHeaderContainer>

                        <Spacer Size="extra-extra-small" />

                        <Select
                            closeMenuOnSelect={false}
                            defaultValue={[]}
                            getOptionLabel={option => option.DisplayName}
                            getOptionValue={option => option.UserId}
                            isLoading={TopLeaders.IsLoading}
                            isMulti
                            // components={{ ValueContainer }}
                            hideSelectedOptions={false}
                            isSearchable
                            onBlur={this.onBlurFilter_TopLeaders}
                            onChange={data => this.onChangeFilter_TopLeaders(data)}
                            onFocus={this.onFocusFilter_TopLeaders}
                            options={TopLeaders.Users}
                            placeholder={t('Filter by Top Leader')}
                            styles={customStyles}
                            menuPosition="fixed"
                        />
                    </styles.FilterContainer>
                </styles.FiltersSubContainer>
            </styles.FiltersContainer>
        );
    }

    renderPopoverContent = ContentType => {
        // var { t } = this.props;

        return (
            <styles.PopoverContent className="PopoverContent">
                {ContentType === 'Companies' && <PageText FontFamily="medium-italic" FontSize="medium-1" JustifyContent="center" NoMargin Text="Shows Employees who belong in the selected companies" TextAlign="center" />}
                {ContentType === 'DHCs' && <PageText FontFamily="medium-italic" FontSize="medium-1" JustifyContent="center" NoMargin Text="Shows all Employees who have a dhc in the selected dhcs" TextAlign="center" />}
                {ContentType === 'Leaders' && <PageText FontFamily="medium-italic" FontSize="medium-1" JustifyContent="center" NoMargin Text="Shows all Employees who have a dhc who has a leader in the selected leaders" TextAlign="center" />}
                {ContentType === 'MiddleLeaders' && <PageText FontFamily="medium-italic" FontSize="medium-1" JustifyContent="center" NoMargin Text="Shows all Employees who have a dhc who has a leader who has a middle leader in the selected middle leaders" TextAlign="center" />}
                {ContentType === 'TopLeaders' && <PageText FontFamily="medium-italic" FontSize="medium-1" JustifyContent="center" NoMargin Text="Shows all Employees who have a dhc who has a leader who has a middle leader who has a top leader in the selected top leaders" TextAlign="center" />}
                {ContentType === 'Users' && <PageText FontFamily="medium-italic" FontSize="medium-1" JustifyContent="center" NoMargin Text="Search by first name, last name, full name or email address of the Employee" TextAlign="center" />}
            </styles.PopoverContent>
        );
    }

    renderShowEmployeeDetailModal = () => {
        // var { t } = this.props;
        var { ShowEmployeeDetailModal, ShowEmployeeDetailModal_Loading } = this.state;

        if (ShowEmployeeDetailModal) {
            return (
                <Info
                    BottomButton="cancel"
                    InformationRenderer={this.renderShowEmployeeDetailModal_Information}
                    Loading={ShowEmployeeDetailModal_Loading}
                    OnHide={() => this.onToggleShowEmployeeDetailModal({ ShowEmployeeDetailModal: false })}
                    Show={ShowEmployeeDetailModal}
                    Size="small"
                />
            );
        }
    }

    renderShowEmployeeDetailModal_Information = () => {
        var { ShowEmployeeDetailModal_Data: UserDetails } = this.state;

        if (!UserDetails || Object.keys(UserDetails).length === 0) return null;

        var { DisplayName, DOB, Email, PhoneNumber, ProfilePhotoUrl, Sex } = UserDetails;

        return (
            <styles.DHCDetailModalInfoContainer className="DHCDetailModalInfoContainer">
                <styles.ProfilePhotoContainer_Popup className="ProfilePhotoContainer_Popup">
                    <ProfilePhoto Sex={Sex || 'Male'} Size="extra-large" Source={ProfilePhotoUrl || ''} />
                </styles.ProfilePhotoContainer_Popup>

                <Spacer Size="extra-small" />

                <PageText FontFamily="semibold" FontSize="medium-3" JustifyContent="flex-start" NoMargin TextAlign="left" Text={DisplayName} />
                <PageText FontFamily="medium-italic" FontSize="medium-1" JustifyContent="flex-start" NoMargin TextAlign="left" Text={Email} />

                {
                    PhoneNumber &&
                    <>
                        <PageText FontFamily="medium-italic" FontSize="medium-1" JustifyContent="flex-start" NoMargin TextAlign="left" Text={PhoneNumber} />
                    </>
                }

                <styles.StyledHR />

                <styles.DHCDetailModalInfoFlexContainer className="DHCDetailModalInfoFlexContainer">
                    <MultiText
                        Texts={[
                            { FontColor: 'black', FontFamily: 'semibold-italic', FontSize: 'medium-1', Text: 'Sex:' },
                            { FontColor: 'black', FontFamily: 'medium-italic', FontSize: 'medium-1', Text: Sex }
                        ]}
                    />
                </styles.DHCDetailModalInfoFlexContainer>
                <styles.DHCDetailModalInfoFlexContainer className="DHCDetailModalInfoFlexContainer">
                    <MultiText
                        Texts={[
                            { FontColor: 'black', FontFamily: 'semibold-italic', FontSize: 'medium-1', Text: 'Birthday:' },
                            { FontColor: 'black', FontFamily: 'medium-italic', FontSize: 'medium-1', Text: DOB }
                        ]}
                    />
                </styles.DHCDetailModalInfoFlexContainer>
            </styles.DHCDetailModalInfoContainer>
        )
    }

    renderViewCount = () => {
        var { t } = this.props;

        var { PageNo, PageSize, TotalRecords } = this.state;

        if (!TotalRecords) TotalRecords = 0;

        return (
            <div className="ViewCount">
                <PageText ElementType="span" FontFamily="medium" FontSize="medium-1" Text={t('items_count_viewing')} />
                &nbsp;
                <PageText ElementType="span" FontFamily="semibold" FontSize="medium-1" Text={`${!TotalRecords ? 0 : ((PageNo - 1) * PageSize) + 1} - ${(PageNo * PageSize) < TotalRecords ? (PageNo * PageSize) : TotalRecords}`} />
                &nbsp;
                <PageText ElementType="span" FontFamily="medium" FontSize="medium-1" Text={t('of')} />
                &nbsp;
                <PageText ElementType="span" FontFamily="semibold" FontSize="medium-1" Text={`${TotalRecords} Employees`} />
            </div>
        )
    }

    render() {
        // var { t } = this.props;

        return (
            <>
                {this.props.TryingDeliverySiteAction && <Loading />}

                {this.renderFilters()}
                {this.renderEmployees()}

                {this.renderAddEmployeeModal()}
                {this.renderShowEmployeeDetailModal()}
            </>
        )
    }
}

const mapStateToProps = state => {
    return {
        Device: state.Window.Device,

        TryingDeliverySiteAction: state.DeliverySite.TryingDeliverySiteAction,
        TryingDeliverySiteActionError: state.DeliverySite.TryingDeliverySiteActionError
    };
};

export default withTranslation()(connect(mapStateToProps, { DeliverySite_GetCompanies_Basic, DeliverySite_GetEmployees, DeliverySite_GetDHCs_Basic, DeliverySite_GetEmployeeDetails, DeliverySite_GetLeaders_Basic, DeliverySite_GetMiddleLeaders_Basic, DeliverySite_GetTopLeaders_Basic, DeliverySite_InsertEditEmployee } )(EmployeesComponent));